var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { transform: "translateY(-1px)" } }, [
    _c("div", { staticClass: "kfbox" }, [
      _c("div", { staticClass: "flex-between ph20" }, [
        _c("span", { staticClass: "icon18a pl40 col4d f14 lh25" }, [
          _vm._v("微信 8440824"),
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btncopy flex-column align-center",
            attrs: { type: "button", "data-clipboard-text": "8440824" },
            on: { click: _vm.copy },
          },
          [_vm._v("复制\n      ")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex-between pl20 pr20 pt15 pb15" }, [
        _c("span", { staticClass: "icon18a pl40 col4d f14 lh25" }, [
          _vm._v("微信 8133835"),
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btncopy flex-column align-center",
            attrs: { type: "button", "data-clipboard-text": "8133835" },
            on: { click: _vm.copy },
          },
          [_vm._v("复制\n      ")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex-between pl20 pr20 pb10" }, [
        _c("span", { staticClass: "icon18a pl40 col4d f14 lh25" }, [
          _vm._v("微信 4901090"),
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btncopy flex-column align-center",
            attrs: { type: "button", "data-clipboard-text": "4901090" },
            on: { click: _vm.copy },
          },
          [_vm._v("复制\n      ")]
        ),
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "flex-between align-center pt5" }, [
        _c("span", { staticClass: "f14 lh22" }, [
          _vm._v("vip心易投诉微信：miyazhu777"),
        ]),
        _c(
          "button",
          {
            staticClass: "btncopy flex-column align-center",
            attrs: { type: "button", "data-clipboard-text": "miyazhu777" },
            on: { click: _vm.copy },
          },
          [_vm._v("复制\n      ")]
        ),
      ]),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _vm._m(2),
      _vm._v(" "),
      _vm._m(3),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "f14 lh22", staticStyle: { color: "#4d4d4d" } },
      [
        _vm._v("vip心易售后电话："),
        _c(
          "a",
          {
            staticStyle: { color: "#4d4d4d" },
            attrs: { href: "tel:18989545463" },
          },
          [_vm._v("18989545463")]
        ),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "f13 lh22 pv10", staticStyle: { color: "#4d4d4d" } },
      [
        _c("b", [_vm._v("主要负责：")]),
        _vm._v(
          "弥亚猪平台的售前服务 成交换绑 售后服务 约定中介交易 业务介绍 业务分流\n      有任何不清楚的问题都可以咨询综合客服\n    "
        ),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "f13 lh22", staticStyle: { color: "#4d4d4d" } },
      [
        _c("b", [_vm._v("客服服务时间：")]),
        _vm._v(
          "凌晨0:00-24:00 24小时在线 客服轮班上岗 全年无休 欢迎咨询 用餐时间回复会稍微延迟 敬请理解\n      中餐11点 晚餐17点 夜宵22点\n    "
        ),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex-center align-center pt10" }, [
      _c("span", { staticClass: "kfgb flex-column align-center f14" }, [
        _vm._v("关闭"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }